import { useUnit } from 'effector-react';
import { $theme, setTheme } from './themeStore';

export const useTheme = () => {
  const theme = useUnit($theme);
  return { theme, setTheme } as const;
};
